import React, { useState } from 'react';
import { X, Star, Check, MessageSquare, QrCode, Smartphone } from 'lucide-react';
import { QR_IMAGE_URL, UPI_ID, PAYEE_NAME, WHATSAPP_NUMBER } from '../../data/constants';

export const QRCodeModal = ({ 
  show, 
  onClose, 
  amount, 
  title, 
  onPaymentComplete, 
  onWhatsAppConfirm 
}) => {
  const [showScanQR, setShowScanQR] = useState(false);
  
  if (!show) return null;

  const handleUPIPay = () => {
    const upiLink = `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(PAYEE_NAME)}&am=${amount}&cu=INR&tn=${encodeURIComponent(`${title} - JustOffs`)}`;
    window.location.href = upiLink;
  };

  const handleWhatsAppConfirm = () => {
    const message = encodeURIComponent(`Hi! I have paid ₹${amount} for JustOffs ${title}. Please confirm.`);
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
    if (onWhatsAppConfirm) onWhatsAppConfirm();
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4" onClick={onClose} data-testid="qr-modal">
      <div className="bg-white rounded-xl w-full max-w-sm p-6 text-center relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 p-1 hover:bg-slate-100 rounded-lg" data-testid="qr-modal-close">
          <X className="w-5 h-5 text-slate-400" />
        </button>
        <div className="w-12 h-12 bg-slate-800 rounded-xl flex items-center justify-center mx-auto mb-3">
          <Star className="w-6 h-6 text-white fill-white" />
        </div>
        <h3 className="text-lg font-bold text-slate-800 mb-1">{title} - ₹{amount}</h3>
        <p className="text-slate-500 text-sm mb-4">Valid for 1 month</p>
        
        {/* Toggle between UPI Pay and Scan QR */}
        {!showScanQR ? (
          <>
            {/* UPI Pay Option */}
            <button 
              onClick={handleUPIPay} 
              className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-3 rounded-xl font-semibold hover:from-purple-700 hover:to-indigo-700 transition flex items-center justify-center gap-2 mb-3 shadow-md" 
              data-testid="upi-pay-btn"
            >
              <Smartphone className="w-5 h-5" /> Pay with UPI App
            </button>
            
            {/* Scan Me fallback */}
            <button 
              onClick={() => setShowScanQR(true)} 
              className="w-full bg-slate-100 text-slate-700 py-3 rounded-xl font-semibold hover:bg-slate-200 transition flex items-center justify-center gap-2 mb-4" 
              data-testid="scan-me-btn"
            >
              <QrCode className="w-5 h-5" /> Scan Me (if UPI fails)
            </button>
          </>
        ) : (
          <>
            {/* QR Code Display */}
            <div className="bg-slate-50 rounded-lg p-4 mb-4">
              <img src={QR_IMAGE_URL} alt="UPI QR Code" className="w-48 h-48 mx-auto rounded-lg" />
            </div>
            <div className="text-sm text-slate-600 mb-4">
              <p className="font-medium">UPI ID: {UPI_ID}</p>
              <p>Payee: {PAYEE_NAME}</p>
            </div>
            <p className="text-xs text-slate-500 mb-4">Scan with any UPI app (PhonePe, GPay, Paytm)</p>
            
            {/* Back to UPI Pay button */}
            <button 
              onClick={() => setShowScanQR(false)} 
              className="w-full bg-slate-100 text-slate-600 py-2 rounded-lg font-medium hover:bg-slate-200 transition text-sm mb-3"
            >
              ← Back to UPI Pay
            </button>
          </>
        )}
        
        <button onClick={onPaymentComplete} className="w-full bg-slate-800 text-white py-2.5 rounded-lg font-semibold hover:bg-slate-900 transition" data-testid="payment-complete-btn">
          <Check className="w-4 h-4 inline mr-2" /> I've Completed Payment
        </button>
        <button onClick={handleWhatsAppConfirm} className="w-full mt-2 text-green-600 py-2 font-medium hover:underline text-sm" data-testid="whatsapp-confirm-btn">
          <MessageSquare className="w-4 h-4 inline mr-2" /> Confirm on WhatsApp
        </button>
      </div>
    </div>
  );
};
